import { Component,  OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Select, Store } from '@ngxs/store';
import { DesktopStorageService } from '../services/storage.service';
import { AuthGuardedPage } from '../authGuardedPage';
import { DesktopErrorHandler } from '../services/errorHandler.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonService, Patient, Family, FamilyPage, Provider, ClearCurrentFamily, GetPageOfFamilies, Log, PractitionerGroupEntity, GetTeamsForUser, sanitizeIdentifier} from 'huddyapi';
import { Observable, Subscription, interval } from 'rxjs';
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { Filter } from '../components/patient-list-filter/filter';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FamilyListFilter } from '../components/family-list-filter/family-list-filter.component';
import { EditFamilyDialog } from '../components/edit-family-dialog/edit-family-dialog-component';
import { CommunityConfigService, UserTeam } from '../services/community-config.service';



@Component({
  selector: 'app-families',
  templateUrl: './families.component.html',
  styleUrls: ['./families.component.scss']
})
export class FamiliesComponent extends AuthGuardedPage implements OnInit  {
  
  userSubscription: any;

  saving: boolean;
  creating: boolean;
  user: any;
  families : Family[] = [];
  page : FamilyPage;
  pageNum : number = 0;
  pageSize : number = 10;
  sort : string = 'identifier';
  sortDir : string = 'desc';
  loading : boolean =true;
  lastFetch : number = 0;
  showAllStatuses : boolean = false;
  filters : Filter[] = [];
  searchField : string = '';
  executedSearchField : string = '';
  @ViewChildren(FamilyListFilter) filterComponents: QueryList<FamilyListFilter>;
  displayedColumns : DisplayedColumn[] = 
  [
    { "name" :  "hasLateAppointments", "displayName" : "Running Late?" },
    { "name" :  "hasLateEvaluations", "displayName" : "Evaluation Lateness" },
    { "name" :  "identifier", "displayName" : "Identifier" },
    { "name" :  "namedPrimary", "displayName" : "Primary Contact" },
    { "name" :  "status", "displayName" : "Status" },
    { "name" :  "teams", "displayName" : "Teams" },
    { "name" :  "serviceLevel", "displayName" : "Service Level" },
    { "name" :  "primaryAddress", "displayName" : "Address" },
    { "name" :  "primaryPhone", "displayName" : "Phone" },
    { "name" :  "tags", "displayName" : "Tags" },
  ];
  
  selectedColumns : string[] = 
  [
    "hasLateAppointments",
    "hasLateEvaluations",
    "identifier",
    "namedPrimary",
    "status",
    "teams",
    "serviceLevel",
    "primaryAddress",
    "primaryPhone",
    "tags"
  ];
  public displayColumnsForm : UntypedFormGroup;
  @Select(state => state.familyState.currentPage) families$: Observable<FamilyPage>;
  familySubscription: Subscription;
  providerSubscription: Subscription;
  providerEndpointsubscription : Subscription;
  providers: Provider[];
  @Select(state => state.compassState.providers) providers$: Observable<Provider[]>;
  currentTeam : UserTeam;

 
  constructor(
    private errorHandler: DesktopErrorHandler,
    public commonService : CommonService,
    public store : Store,
    public route: ActivatedRoute,
    public fb : UntypedFormBuilder,
    public storageService: DesktopStorageService,
    public router: Router,
    public dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    super(commonService);
    this.logout(this, true);
    CommonService.onboardingPersona = null;
    this.saving = false;
    this.creating = null;
    this.matIconRegistry.addSvgIcon('search',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/content-icon/ic-02.svg'));

    this.filters = [];
    this.filters.push (new Filter());
    this.filters[this.filters.length -1].index = 0;

  }
  ngOnInit(): void {
 
    this.userSubscription = this.commonService.getUserSubject().subscribe((user: any) => {
      this.user = user || '';
      this.store.dispatch(new GetTeamsForUser())
    });
    CommunityConfigService.currentTeamSubject.subscribe(team => {
      console.log('subscribing to config service currentTeam = ', team);
      if (team) {
        const refresh = team != this.currentTeam;
        this.currentTeam = team;
        if (refresh)
          this.getPageOfFamilies();
      }
    });
    this.displayColumnsForm = this.fb.group({
      selectedColumns: []
     });
    this.displayColumnsForm.controls['selectedColumns'].setValue(this.selectedColumns);
    this.familySubscription = this.families$.subscribe((familyPage: FamilyPage) => {
      Log.logClassLevel(0, 'Families', 'familyPage', familyPage);
        this.families = [];
        this.page = familyPage;
        if (familyPage && familyPage.content) {
          this.families = this.families.concat(familyPage?.content);
          this.loading = false;
        }
        Log.logClassLevel(0, 'Families', 'families', this.families, this.page);
        this.providerSubscription = this.providers$.subscribe((providers: Provider[]) => {
          this.providers = providers;
          const providerName =  { "name" :  "providerName", "displayName" : "Provider Name" }
          if (this.isMultiProvider() && this.displayedColumns.map(c => c.name).indexOf("providerName") === -1) {
            this.displayedColumns.splice(2, 0,  providerName);
          }
        });
    });

  }


  ngOnDestroy(): void {

    if(this.userSubscription?.unsubscribe)
      this.userSubscription.unsubscribe();
    if(this.familySubscription?.unsubscribe)
      this.familySubscription.unsubscribe();
    this.familySubscription.unsubscribe();  
    this.providerSubscription.unsubscribe();

  }



  setCreating(creating: boolean) {
    if(!this.saving)
      this.creating = creating;
  }


  getNumberOfFamilies() : number {
    if (this.page) {
      return this.page.totalElements;
    }
  }

  pageFamiliesList($event) {
    if (this.pageSize === $event.pageSize) {
      this.pageNum = $event.pageIndex;
    } else {
      this.pageNum = 0;
    }
    this.pageSize = $event.pageSize;
    this.getPageOfFamilies();
  }

  changeSort($event) {
    //this.loading = true;
    this.sort = $event.active;
    this.sortDir = $event.direction;
    this.getPageOfFamilies();
  }

  cleanupIdentifier(familyIdentifier : string, identifier : string) {
    return sanitizeIdentifier(familyIdentifier, identifier);
  }

  isMultiProvider() : boolean {
    return this.providers && this.providers.length > 1;
  }

  disableControls() {
    return (new Date().getTime() - this.lastFetch < 5000);
  }

  toggleChangeStatus() {
    this.showAllStatuses = !this.showAllStatuses;
    this.getPageOfFamilies();
  }

  getPageOfFamilies() {
    if (new Date().getTime() - this.lastFetch < 5000) {
      return;
    }
    let statuses : string[] = this.showAllStatuses ? [] :
    ['ONBOARDED', 'ELIGIBLE', 'PENDING_ONBOARDING', 'COMPLETE'];
    console.log('getPageOfFamilies', this.showAllStatuses, statuses);
    this.lastFetch = new Date().getTime();
    this.loading = true;
    let filterStr : string = '';
    for (let filter of this.filters) {
      if (filter.columnValue && filter.operatorValue) {
      filterStr = filterStr +  filter.columnValue + filter.operatorValue + filter.expressionValue + '*';
      }
    }
    console.log('getPageofFamilies', this.currentTeam);
    let teamsArr : string [] = [];
    // console.error("FAMILY GET PAGE OF FAMILIES");
    const action : GetPageOfFamilies = new GetPageOfFamilies(this.pageNum, this.pageSize, filterStr, this.executedSearchField, this.sort, this.sortDir, teamsArr, statuses);
    // console.log('GetPageOfFamilies', 'dispatch', action);
    this.store.dispatch(action)
  }

  addFilter() {
    if (this.filters.length < 3) {
      this.filters.push(new Filter());
      this.filters[this.filters.length -1].index = this.filters.length -1;
    }
  }

  onFilterEdit() {
    this.pageNum = 0;
    this.searchField = '';
    this.executedSearchField = '';
    for (let filterComponent of this.filterComponents) {
      filterComponent.updateFilterFromEdited();
    }
    this.getPageOfFamilies();
  }

  onRemoveFilter($event) {
    console.log($event);
    if (this.filters.length > 1) {
      this.filters.splice($event.index,  1);
      let index : number = 0;
      for (let filter of this.filters) {
        filter.index = index++;
      } 
    } else if (this.filters.length === 1) {
      this.filters[0].columnValue = '';
      this.filters[0].expressionValue = '';
      this.filters[0].operatorValue = '';
    } else {
      $event.clear();
    }
    this.getPageOfFamilies();
  }

  search($event) {
    this.filters = [];
    this.filters.push(new Filter());
    this.filters[this.filters.length -1].index = 0;
     
    if (this.filterComponents) {
      for (let listFilter of this.filterComponents) {
        listFilter.clear();
      }
    }
    this.pageNum = 0;
    console.log($event,this.searchField, $event.target.value);
    this.executedSearchField = this.searchField;
    this.getPageOfFamilies();
  } 

  clearSearchField() {
    this.searchField = '';
    this.executedSearchField = '';
    this.getPageOfFamilies();
  }

  addFamily() {
    this.store.dispatch(new ClearCurrentFamily());
    let familyDialog = this.dialog.open(EditFamilyDialog, {
      width: '600px',
      height: '650px',
      data: {
        family: {},
        fromFamilyPatient: false
      }
    });
    familyDialog.afterClosed().subscribe(family => interval(2000).subscribe(t => this.getPageOfFamilies()));
  }

  getPageNumber() : number {
    let ret : number = 0;
    if (this.page) {
      ret = this.page.number;
    }
    return ret;
  }

  getPatientName(patient : Patient) : string {
    let ret : string = patient.friendlyName;
    if (!ret || ret.indexOf("null ") > -1) {
      ret = patient.username;
    }
    return ret;
  }
  
  checkSearchValue($event) {
    this.searchField = this.searchField.replace(/[^a-zA-Z0-9 '-.]/g, '');
  }

  onClickFamily(family : Family) {
  //  console.log('onCickFamily', family); 
   this.router.navigateByUrl('/family/' + family.id);
  }



}

export interface DisplayedColumn {
  displayName : string;
  name : string;
}


